import { useSyncExternalStore } from 'react'
import {
  getVoiceCallSession,
  subscribeVoiceCallSession,
} from '../stores/voice-call-store'

export function useVoiceCallSession() {
  return useSyncExternalStore(subscribeVoiceCallSession, getVoiceCallSession, getVoiceCallSession)
}
